import { useMemo, useRef, useState } from 'react';

import { debounce } from '@cian/ui-kit/internal/utils';
import { useDispatch, useSelector } from 'react-redux';
import { useEventOnCalculateSubsidizedMortgage } from 'shared/subsidizedCalculator/hooks/useEventOnCalculateSubsidizedMortgage';
import { setCreditTerm, setFlatPrice } from '../../../redux';
import { selectCalculatorValues } from '../../../selectors/selectCalculatorValues';

export const useSliderInputs = () => {
  const dispatch = useDispatch();
  const eventRef = useRef<HTMLDivElement | null>(null);
  const calculatorState = useSelector(selectCalculatorValues);
  const [priceSliderValue, setPriceSliderValue] = useState<number>(calculatorState.price);
  const [termSliderValue, setTermSliderValue] = useState<number>(calculatorState.term);

  const debouncedSetCreditTermHandler = useMemo(
    () => debounce((val: number) => dispatch(setCreditTerm(val)), 100),
    [dispatch],
  );

  const debouncedSetFlatPriceHandler = useMemo(
    () => debounce((val: number) => dispatch(setFlatPrice(val)), 100),
    [dispatch],
  );

  useEventOnCalculateSubsidizedMortgage(eventRef);

  const handleChangePrice = (value: number) => {
    setPriceSliderValue(value);
    debouncedSetFlatPriceHandler(value);
  };

  const handleChangeLoanTerm = (value: number) => {
    setTermSliderValue(value);
    debouncedSetCreditTermHandler(value);
  };

  return {
    eventRef,
    priceSliderValue,
    termSliderValue,
    handleChangePrice,
    handleChangeLoanTerm,
    calculatorState,
  };
};
